import { useCallback } from 'react';
import { useParams } from 'react-router';
import { isLang, type Lang } from '@/i18n';

/** Current UI language from the URL (`/:lang/...`). */
export function useLang(): Lang {
  const { lang } = useParams();
  return isLang(lang) ? lang : 'en';
}

/** Build a localized path: lp('/catalogue') -> '/ar/catalogue'. */
export function useLocalizedPath() {
  const lang = useLang();
  return useCallback((path = '') => `/${lang}${path.startsWith('/') || path === '' ? path : `/${path}`}`, [lang]);
}

/** Replace the language segment of a pathname. */
export function switchLanguagePath(pathname: string, next: Lang): string {
  const parts = pathname.split('/');
  if (isLang(parts[1])) parts[1] = next;
  else parts.splice(1, 0, next);
  return parts.join('/') || `/${next}`;
}
